import { render, staticRenderFns } from "./productimage-swiper.vue?vue&type=template&id=5e49f4ce&"
import script from "./productimage-swiper.vue?vue&type=script&lang=js&"
export * from "./productimage-swiper.vue?vue&type=script&lang=js&"
import style0 from "./productimage-swiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports